import * as React from 'react';
import { SectionHelper, Box } from '@wix/design-system';
import { Trans } from 'react-i18next';

export const PlanRemovedSectionHelper = ({ planName }) => {
  return (
    <Box marginTop='9px'>
      <SectionHelper appearance='standard' showCloseButton={false}>
        <Trans
          i18nKey='change_plan.current_plan_modal.explanation_advanced'
          values={{
            planName,
          }}
        >
          <strong>{planName}</strong>
        </Trans>
      </SectionHelper>
    </Box>
  );
};
